import type { ComponentProps, FC } from 'react';
import type { ExtraProps } from 'streamdown';

type MarkdownTaskCheckboxProps = ComponentProps<'input'> & ExtraProps;

/**
 * GFM task-list items (`- [x] done`) render a bare, read-only checkbox. Give
 * it a name so it is not an unlabelled form control; the item text follows.
 */
export const MarkdownTaskCheckbox: FC<MarkdownTaskCheckboxProps> = ({
  node: _node,
  type,
  checked,
  ...props
}) =>
  type === 'checkbox' ? (
    <input
      {...props}
      type="checkbox"
      checked={checked}
      readOnly
      disabled
      aria-label={checked ? 'Done' : 'Not done'}
    />
  ) : (
    <input type={type} checked={checked} {...props} />
  );
